import type { Project } from '../../api/types'
import { formatCurrency } from '../../lib/formatters'
import { projectHasBilledPayApps } from '../../lib/projectMoneyDisplay'

const PayIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.65" aria-hidden="true">
    <path d="M3 6h18v12H3zM15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
  </svg>
)

type Props = {
  project?: Project | null
  onClick: () => void
  testId?: string
}

export default function ArOpenButton({ project, onClick, testId = 'ar-open-btn' }: Props) {
  const outstanding = parseFloat(project?.outstanding ?? '0') || 0
  const display = outstanding > 0
    ? formatCurrency(outstanding)
    : (project && projectHasBilledPayApps(project) ? formatCurrency(0) : '—')
  const aria = `AR · Accounts receivable · ${display} open`

  return (
    <button
      type="button"
      className="ar-open-btn"
      data-testid={testId}
      aria-label={aria}
      onClick={onClick}
    >
      <PayIcon />
      <span>
        <strong>AR</strong>
        <small>{display} open</small>
      </span>
    </button>
  )
}
